/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

   //cambios de logo y colores en header --- 
    let template_web = document.getElementById("template_web").value;
    if(template_web == "template-product"){
     var element_headera = document.getElementById("header_wrapper");
       element_headera.classList.add("meganav--visible");
     var element_header = document.getElementById("header");
     element_header.classList.add("header_transparent");
     document.getElementById("MainContent").style.marginTop = "-100px";
    }
   //cambios de logo y colores en header ///
   

  

  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


onscroll = (event) => {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    let template_web = document.getElementById("template_web").value;
    if(template_web == "template-index"){
      var navtext = document.getElementsByClassName("navtext");
          for (let i = 0; i < navtext.length; i++) {
            navtext[i].style = "--link: white";
          }
    }
  }else{
    let template_web = document.getElementById("template_web").value;
    if(template_web == "template-index"){
      var navtext = document.getElementsByClassName("navtext");
          for (let i = 0; i < navtext.length; i++) {
            navtext[i].style = "--link: white";
          }
    }
  }
};
function bigImg(x) {
   let template_web = document.getElementById("template_web").value;
    if(template_web == "template-product"){
     var element_header = document.getElementById("header");
     element_header.classList.remove("header_transparent");
       
    }
    if(template_web == "template-index"){
       var element_headera = document.getElementById("header_wrapper");
       element_headera.classList.remove("meganav--visible");
       var element_header = document.getElementById("header");
       element_header.style = "background: #00000096;";

       if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          var dropdowm = document.getElementById("dropdown-2248d5060f8de4a2d33709faf993fee5"); 
         dropdowm.style = "--bg: white";
         var nav_link = document.getElementsByClassName("navlink--child");
          for (let i = 0; i < nav_link.length; i++) {
            nav_link[i].style = "--link: black";
          }
       }else{
         var dropdowm = document.getElementById("dropdown-2248d5060f8de4a2d33709faf993fee5"); 
         dropdowm.style = "--bg: #00000096";
         var nav_link = document.getElementsByClassName("navlink--child");
          for (let i = 0; i < nav_link.length; i++) {
            nav_link[i].style = "--link: #ffffff";
          }
         var navtext = document.getElementsByClassName("navtext");
          for (let i = 0; i < navtext.length; i++) {
            navtext[i].style = "--link: white";
          }
       }
       
      
    }else{
        var element_headera = document.getElementById("header_wrapper");
       element_headera.classList.add("meganav--visible");
    }
}
function normalImg(x) {
    let template_web = document.getElementById("template_web").value;
    if(template_web == "template-product"){
      var element_header = document.getElementById("header");
     element_header.classList.add("header_transparent");
      
    }
  if(template_web == "template-index"){
     
      var element_header = document.getElementById("header");
       element_header.style = "background: transparent;";
  }else if(template_web == "template-product"){
    var element_headera = document.getElementById("header_wrapper");
       element_headera.classList.add("meganav--visible");
  }else{
     var element_headera = document.getElementById("header_wrapper");
       element_headera.classList.remove("meganav--visible");
  }
}



function añadir_click_btn_home(){
 
     var elems = document.getElementsByClassName('zoomywishid');
        for(var i = 0; i < elems.length; i++) {
            var elem = elems[i];
              elem.setAttribute("onclick","mostrarDatos2();");
        }
  var elemt2  = document.getElementsByClassName('removefromwishlist');
        for(var i = 0; i < elemt2.length; i++) {
            var elem2 = elemt2[i];
              elem2.setAttribute("onclick","mostrarDatos2();");
        }
  document.getElementById("ZlistWishlist").setAttribute("onclick","mostrarDatos2();");;
  
}
const myTimeout = setTimeout(añadir_click_btn_home, 2000);


mostrarDatos()
  function mostrarDatos(){
 var dato1 = JSON.parse(localStorage.getItem('myzooomy__wishlist'));
 /* console.log(dato1.length);*/
    document.getElementById("count_wishlist").innerHTML = dato1.length;
      document.getElementById("count_wishlist_desktop").innerHTML = dato1.length;
    
}
let timeout;

function mostrarDatos2() {
  timeout = setTimeout(mostrarDatos, 1000);
}


